export const styleSheet = () => ({
    pageRoot: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '90vh',
    },
    mainHeading:{
        fontSize: "20px",
        fontWeight: '600',
        margin: 0,
        textAlign: 'center'
    },
    mainContent:{
        margin: 0,
        textAlign: 'center'
    },
  });